var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Col, Spin, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { i18n } from "../../../../translations";
import { GroupAnalyticsNewTKeys } from "../../../../translations/keys";
import Chart from "react-apexcharts";
var IdlingMachinesCard = function (props) {
    var _a = __read(useState(true), 2), loading = _a[0], setLoading = _a[1];
    var _b = __read(useState([]), 2), barData = _b[0], setBarData = _b[1];
    useEffect(function () {
        setBarData(props.data);
        setLoading(false);
    }, [props.data]);
    return (React.createElement(Col, { span: 12 },
        React.createElement(Spin, { spinning: loading },
            React.createElement(Card, { headStyle: { fontSize: '16px' }, title: React.createElement(React.Fragment, null,
                    i18n.t(GroupAnalyticsNewTKeys.bottom5ByIdle),
                    " ",
                    React.createElement(Tooltip, { placement: "rightBottom", title: i18n.t(GroupAnalyticsNewTKeys.idlingMeaning) },
                        React.createElement(InfoCircleOutlined, null))), bodyStyle: { height: "100%" } },
                React.createElement(Chart, { options: {
                        chart: {
                            type: 'bar',
                            height: 200,
                        },
                        plotOptions: {
                            bar: {
                                horizontal: true,
                                distributed: true,
                            },
                        },
                        legend: {
                            show: false
                        },
                        dataLabels: {
                            enabled: false
                        },
                        xaxis: {
                            categories: barData.map(function (x) { return x.x; }),
                        },
                        yaxis: {
                            title: {
                                text: undefined
                            },
                        },
                        fill: {
                            opacity: 1
                        },
                    }, series: [{
                            data: barData.map(function (x) { return x.y; })
                        }], type: "bar", height: 200 })))));
};
export default IdlingMachinesCard;
